import * as materialIcons from 'react-icons/md';
import { MdAppArrowLeft } from './MdAppArrowLeft';
import { MdBankIdentityFilled } from './MdBankIdentityFilled';
import { MdClickToPay } from './MdClickToPay';
import { MdCloseFilled } from './MdCloseFilled';
import { MdCurrencyFlagAud } from './MdCurrencyFlagAud';
import { MdCurrencyFlagBgn } from './MdCurrencyFlagBgn';
import { MdCurrencyFlagBtc } from './MdCurrencyFlagBtc';
import { MdCurrencyFlagCad } from './MdCurrencyFlagCad';
import { MdCurrencyFlagChf } from './MdCurrencyFlagChf';
import { MdCurrencyFlagCzk } from './MdCurrencyFlagCzk';
import { MdCurrencyFlagDkk } from './MdCurrencyFlagDkk';
import { MdCurrencyFlagEur } from './MdCurrencyFlagEur';
import { MdCurrencyFlagGbp } from './MdCurrencyFlagGbp';
import { MdCurrencyFlagHuf } from './MdCurrencyFlagHuf';
import { MdCurrencyFlagJpy } from './MdCurrencyFlagJpy';
import { MdCurrencyFlagNok } from './MdCurrencyFlagNok';
import { MdCurrencyFlagNzd } from './MdCurrencyFlagNzd';
import { MdCurrencyFlagPln } from './MdCurrencyFlagPln';
import { MdCurrencyFlagRon } from './MdCurrencyFlagRon';
import { MdCurrencyFlagSek } from './MdCurrencyFlagSek';
import { MdCurrencyFlagTry } from './MdCurrencyFlagTry';
import { MdCurrencyFlagUnknown } from './MdCurrencyFlagUnknown';
import { MdCurrencyFlagUsd } from './MdCurrencyFlagUsd';
import { MdCurrencyFlagZar } from './MdCurrencyFlagZar';
import { MdHandCoinOutline } from './MdHandCoinOutline';
import { MdHome1Filled } from './MdHome1Filled';
import { MdHome2Filled } from './MdHome2Filled';
import { MdLoan } from './MdLoan';
import { MdPartners } from './MdPartners';
import { MdUmbrellaOpen } from './MdUmbrellaOpen';
export const icons = {
    ...materialIcons,
    MdLoan,
    MdPartners,
    MdHome1Filled,
    MdHome2Filled,
    MdBankIdentityFilled,
    MdClickToPay,
    MdCloseFilled,
    MdAppArrowLeft,
    MdCurrencyFlagAud,
    MdCurrencyFlagBgn,
    MdCurrencyFlagBtc,
    MdCurrencyFlagGbp,
    MdCurrencyFlagCad,
    MdCurrencyFlagChf,
    MdCurrencyFlagCzk,
    MdCurrencyFlagDkk,
    MdCurrencyFlagEur,
    MdCurrencyFlagHuf,
    MdCurrencyFlagJpy,
    MdCurrencyFlagNok,
    MdCurrencyFlagNzd,
    MdCurrencyFlagPln,
    MdCurrencyFlagRon,
    MdCurrencyFlagSek,
    MdCurrencyFlagTry,
    MdCurrencyFlagUnknown,
    MdCurrencyFlagUsd,
    MdCurrencyFlagZar,
    MdHandCoinOutline,
    MdUmbrellaOpen,
};
